<template>
  <v-tooltip
    class="help-tooltip-container"
    bottom
    max-width="300"
    content-class="help-content"
  >
    <i slot="activator" class="fa fa-question-circle help-tooltip" />
    <span v-html="tooltip" />
  </v-tooltip>
</template>

<script>
export default {
  props: ['tooltip'],
}
</script>

<style scoped>
.help-tooltip-container {
  position: absolute;
  top: 0;
  right: 0;

  cursor: help;
}

.help-tooltip {
  font-size: 1.25em;
  color: #65c635;
}

.help-content {
  color: #fff;
  font-size: 1em;
  text-align: center;
  background-color: #65c635;
}
</style>

<style>
.has-tooltip {
  position: relative;
}
</style>
